import { useSelector } from "react-redux"


const FirmaCezaVeUyariSorgulama = () => {

  return (
    <div>FirmaCezaVeUyariSorgulama</div>
  )
}

export default FirmaCezaVeUyariSorgulama